var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "photo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5C5.89543 5 5 5.89543 5 7V12.5857L7.29289 10.2928L7.30662 10.2794C7.909 9.69974 8.66419 9.33008 9.5 9.33008C10.3358 9.33008 11.091 9.69974 11.6934 10.2794L11.7071 10.2928L14 12.5857L14.2929 12.2928L14.3066 12.2794C14.909 11.6997 15.6642 11.3301 16.5 11.3301C17.3358 11.3301 18.091 11.6997 18.6934 12.2794L18.7071 12.2928L19 12.5857V7C19 5.89543 18.1046 5 17 5H7ZM21 14.999V7C21 4.79086 19.2091 3 17 3H7C4.79086 3 3 4.79086 3 7V14.9998C3 14.9997 3 14.9999 3 14.9998V17C3 19.2091 4.79086 21 7 21H17C19.2091 21 21 19.2091 21 17V15.0009C21 15.0003 21 14.9996 21 14.999ZM19 15.4142L17.3003 13.7145C16.9931 13.4212 16.7159 13.3301 16.5 13.3301C16.2841 13.3301 16.0069 13.4212 15.6997 13.7145L15.4142 14L16.7071 15.2928C17.0976 15.6834 17.0976 16.3165 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L10.3003 11.7145C9.99311 11.4212 9.71594 11.3301 9.5 11.3301C9.28406 11.3301 9.00689 11.4212 8.69966 11.7145L5 15.4142V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V15.4142ZM14 8C14 7.44772 14.4477 7 15 7H15.01C15.5623 7 16.01 7.44772 16.01 8C16.01 8.55228 15.5623 9 15.01 9H15C14.4477 9 14 8.55228 14 8Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.e26b2ee7bdf0d2d1d85989bffa0dc60a.svg";
export { ForwardRef as ReactComponent };